module.exports = __webpack_public_path__ + "img/noticeLog-active.3df1368f.svg";